/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";
import { UserService } from "../settings/user/user.service";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const DefaultCompanyBranchDivisionService = {

  defaultData: undefined,

  async getDefault() {
    const requestScreenData = {
      url: "api/UserDefaultCompanyBranchDivision",
      top: "1",
      filter: `UserCode eq '${UserService.getUsername()}'`
    };

    if (this.defaultData) {
      return new Promise(async (resolve) => {
        resolve({
          data: {
            value: this.defaultData,
          },
        });
      });
    } else {
      return new Promise(async (resolve, reject) => {
        try {
          var result = await ApiService.oDataGet(requestScreenData);
          this.defaultData = result.data.value;
          resolve(result);
        } catch (error) {
          reject(error);
        }
      });
    }

  }
};

export { DefaultCompanyBranchDivisionService };